export default __webpack_public_path__ + "cb74dc8b551e0eadc0128824551572e3.png";